import { render, staticRenderFns } from "./FoodGroups.vue?vue&type=template&id=0faae984&scoped=true&"
import script from "./FoodGroups.vue?vue&type=script&lang=js&"
export * from "./FoodGroups.vue?vue&type=script&lang=js&"
import style0 from "./FoodGroups.vue?vue&type=style&index=0&id=0faae984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faae984",
  null
  
)

export default component.exports